/**
 * Whether captcha is active in this build.
 *
 * Lives apart from turnstile-widget.tsx because a file that exports both a
 * component and a plain function breaks Fast Refresh: React cannot tell whether
 * to remount or re-run, so it remounts everything on every edit.
 */

import { getTurnstileSiteKey } from '../config/environment';

export function isCaptchaEnabled(): boolean {
  return !!getTurnstileSiteKey();
}
